var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineLifebuoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-5.93 4.83-10.75 10.75-10.75S22.72 6.07 22.72 12 17.9 22.75 11.97 22.75C6.05 22.75 1.22 17.93 1.22 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25S2.72 6.9 2.72 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12c0-2.89 2.35-5.25 5.25-5.25s5.25 2.36 5.25 5.25-2.35 5.25-5.25 5.25S6.75 14.89 6.75 12zm1.5 0c0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91 9 4.37 5.46a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.54 3.54c.29.29.29.76 0 1.06a.775.775 0 0 1-1.06 0zM4.37 19.6a.754.754 0 0 1 0-1.06L7.91 15c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L5.43 19.6c-.14.15-.34.22-.53.22s-.38-.07-.53-.22zM18.51 19.6l-3.54-3.54a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.54 3.54c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22c-.19 0-.38-.07-.53-.22zM14.98 8.99a.754.754 0 0 1 0-1.06l3.54-3.54c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L16.04 9c-.15.14-.34.21-.53.21s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLifebuoy);
export default __webpack_public_path__ + "static/media/vuesax-outline-lifebuoy.8039b7c1c773a8265123a347aa4b1621.svg";
export { ForwardRef as ReactComponent };